import { createReducer, on } from '@ngrx/store';
import { loadAllMitarbeiterSucceeded, loadAllMitarbeiterStart } from '../actions/getAllMitarbeiter.actions';
import { MitarbeiterItem } from '../../mitarbeiter.model';
import {AnredeItem} from '../../anrede.model';
import {loadSalutationsStart, loadSalutationsSucceeded} from '../actions/anrede.actions';
import {RolleItem} from '../../rolle.model';
import {loadRollenStart, loadRollenSucceeded} from '../actions/rolle.actions';
import {addMitarbeiterFailed, addMitarbeiterStart, addMitarbeiterSucceeded} from '../actions/mitarbeiter-add.actions';
import {BrancheItem} from '../../branche.model';
import {loadBranchenStart, loadBranchenSucceeded} from '../actions/branche.actions';
import {FirmaItem} from '../../firma.model';
import {loadFirmaStart, loadFirmaSucceeded} from '../actions/getFirma.actions';
import {editFirmaFailed, editFirmaStart, editFirmaSucceeded} from '../actions/firma-edit.actions';
import {editMitarbeiterFailed, editMitarbeiterStart, editMitarbeiterSucceeded} from '../actions/mitarbeiter-edit.actions';
import {deleteMitarbeiterFailed, deleteMitarbeiterStart, deleteMitarbeiterSucceeded} from '../actions/mitarbeiter-del.actions';
import {
  getFilteredMitarbeiterFailed,
  getFilteredMitarbeiterStart,
  getFilteredMitarbeiterSucceeded
} from "../actions/getFilteredMitarbeiter.actions";
import {
  loadAllMitarbeiterSelectboxStart,
  loadAllMitarbeiterSelectboxSuceeded
} from "../actions/getAllMitarbeiterSelectbox.actions";
import {changeRolleFailed, changeRolleStart, changeRolleSucceeded} from '../actions/change-rolle.actions';
import {loadUserRollenFailed, loadUserRollenStart, loadUserRollenSucceeded} from '../actions/getUserRollen.actions';
import {loadRechteFailed, loadRechteStart, loadRechteSucceeded} from '../actions/getAllRechte.actions';
import {RechteItem} from '../../rechte.model';
import {addRolleFailed, addRolleStart, addRolleSucceeded} from '../actions/rolle-add.actions';
import {deleteRolleFailed, deleteRolleStart, deleteRolleSucceeded} from '../actions/rolle-del.actions';
import {editRolleFailed, editRolleStart, editRolleSucceeded} from '../actions/rolle-edit.actions';
import {FirmaZeitItem} from '@src/app/pages/Mitarbeiterverwaltung/firmaZeit.model';
import {loadFirmaZeitenStart, loadFirmaZeitenSucceeded} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFirmaZeiten.actions';
import {loadFeiertageStart, loadFeiertageSucceeded} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFeiertage.actions';
import {FeiertagItem} from '@src/app/pages/Mitarbeiterverwaltung/feiertage.model';
import {
  addFeiertageFailed,
  addFeiertageStart,
  addFeiertageSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/feiertage-add.actions';
import {SaldoItem} from '@src/app/pages/Mitarbeiterverwaltung/saldo.model';
import {loadSaldoStart, loadSaldoSucceeded} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getSaldo.actions';
import {UserInfoItem} from '@src/app/pages/Mitarbeiterverwaltung/userInfo.model';
import {loadUserInfoStart, loadUserInfoSucceeded} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getUserInfo.actions';
import {
  addUserInfoFailed,
  addUserInfoStart,
  addUserInfoSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/userInfo-add.actions';
import {
  deleteUserInfoFailed,
  deleteUserInfoStart,
  deleteUserInfoSucceeded
} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/saldo-del.actions';

export interface State {
    isLoading: boolean;
    items: MitarbeiterItem[];
    selectboxItems: MitarbeiterItem[];
    firmaZeiten: FirmaZeitItem[];
    feiertage: FeiertagItem[];
    saldos: SaldoItem;
    userinfos: UserInfoItem[];
    anreden: {
      items: AnredeItem[];
    };
    rollen: {
      error: string;
      items: RolleItem[];
    };
    branchen: {
      items: BrancheItem[];
    };
    firma: {
      item: FirmaItem;
    };
  userRollen: {
    items: RolleItem[];
  };
  rechte: {
    items: RechteItem[];
  };
}

export const initialState: State = {
    isLoading: false,
    items: [],
  selectboxItems: [],
  firmaZeiten: [],
  feiertage: [],
  saldos: {userId:null, datum: null, ferien: null, zeit: null},
  userinfos: [],
  anreden: {
    items: [],
  },
  rollen: {
      error: '',
      items: [],
  },
  userRollen: {
    items: [],
  },
  rechte: {
    items: [],
  },
  branchen: {
    items: [],
  },
  firma: {
      item: {id: null, email: null, name: null, telefon: null, arbsol: null, branche: null, ort: null, plz: null, str1: null, str2: null},
  },
};

const ons = [
    on(loadAllMitarbeiterStart, (state: State) => ({ ...state, isLoading: true })),
    on(loadAllMitarbeiterSucceeded, (state: State, action) => ({
        ...state,
        isLoading: false,
        items: action.item,
    })),
  on(loadAllMitarbeiterSelectboxStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadAllMitarbeiterSelectboxSuceeded, (state: State, action) => ({
    ...state,
    isLoading: false,
    selectboxItems: action.item,
  })),
  on(getFilteredMitarbeiterStart, (state: State) => ({ ...state, isLoading: true })),
  on(getFilteredMitarbeiterSucceeded, (state: State, action) => ({
    ...state,
    isLoading: false,
    items: action.item,
  })),
  on(getFilteredMitarbeiterFailed, (state: State) => ({ ...state, isLoading: false })),
  on(loadSalutationsStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadSalutationsSucceeded, (state: State, action) => ({
    ...state,
    anreden: {
      ...state.anreden,
      items: action.anreden,
    },
  })),
  on(loadRollenStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadRollenSucceeded, (state: State, action) => ({
    ...state,
    rollen: {
      ...state.rollen,
      items: action.rollen,
    },
  })),
  on(loadRechteStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadRechteFailed, (state: State) => ({ ...state, isLoading: true })),
  on(loadRechteSucceeded, (state: State, action) => ({
    ...state,
    isLoading: false,
    rechte: {
      ...state.rechte,
      items: action.rechte,
    },
  })),

  on(loadUserRollenStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadUserRollenFailed, (state: State) => ({ ...state, isLoading: false })),
  on(loadUserRollenSucceeded, (state: State, action) => ({
    ...state,
    isLoading: false,
    userRollen: {
      ...state.rollen,
      items: action.rollen,
    },
  })),
  on(loadBranchenStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadBranchenSucceeded, (state: State, action) => ({
    ...state,
    branchen: {
      ...state.branchen,
      items: action.branchen,
    },
  })),
  on(loadFeiertageStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadFeiertageSucceeded, (state: State, action) => ({
    ...state,
    feiertage: action.item,
  })),
  on(loadFirmaZeitenStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadFirmaZeitenSucceeded, (state: State, action) => ({
    ...state,
    firmaZeiten: action.item,
  })),
  on(loadUserInfoStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadUserInfoSucceeded, (state: State, action) => ({
    ...state,
    userinfos: action.item,
  })),
  on(loadFirmaStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadFirmaSucceeded, (state: State, action) => ({
    ...state,
    firma: {
      ...state.firma,
      item: action.item,
    },
  })),
  on(loadSaldoStart, (state: State) => ({ ...state, isLoading: true })),
  on(loadSaldoSucceeded, (state: State, action) => ({
    ...state,
    saldos: action.item,
  })),
  on(addRolleStart, (state: State) => ({ ...state, isAddingRolle: true })),
  on(addRolleSucceeded, (state: State) => ({ ...state, isAddingRolle: false })),
  on(addRolleFailed, (state: State) => ({ ...state, isAddingRolle: false })),
  on(addUserInfoStart, (state: State) => ({ ...state, isAddingRolle: true })),
  on(addUserInfoSucceeded, (state: State) => ({ ...state, isAddingRolle: false })),
  on(addUserInfoFailed, (state: State) => ({ ...state, isAddingRolle: false })),
  on(addMitarbeiterStart, (state: State) => ({ ...state, isAddingFirma: true })),
  on(addMitarbeiterFailed, (state: State) => ({ ...state, isAddingFirma: false })),
  on(addMitarbeiterSucceeded, (state: State) => ({ ...state, isAddingFirma: false })),
  on(addFeiertageStart, (state: State) => ({ ...state, isAddingFirma: true })),
  on(addFeiertageSucceeded, (state: State) => ({ ...state, isAddingFirma: false })),
  on(addFeiertageFailed, (state: State) => ({ ...state, isAddingFirma: false })),
  on(editMitarbeiterStart, (state: State) => ({ ...state, isEditingFirma: true })),
  on(editMitarbeiterFailed, (state: State) => ({ ...state, isEditingFirma: false })),
  on(editMitarbeiterSucceeded, (state: State, action) => ({
    ...state, isEditingFirma: false
  })),

  on(editFirmaStart, (state: State) => ({ ...state, isEditingFirma: true })),
  on(editFirmaFailed, (state: State) => ({ ...state, isEditingFirma: false })),
  on(editFirmaSucceeded, (state: State, action) => ({
    ...state, isEditingFirma: false
  })),

  on(editRolleStart, (state: State) => ({ ...state, isEditingRolle: true })),
  on(editRolleFailed, (state: State) => ({ ...state, isEditingRolle: false })),
  on(editRolleSucceeded, (state: State, action) => ({
    ...state, isEditingRolle: false
  })),

  on(deleteUserInfoStart, (state: State) => ({ ...state, isDeletingMitarbeiter: true })),
  on(deleteUserInfoSucceeded, (state: State) => ({ ...state, isDeletingMitarbeiter: false })),
  on(deleteUserInfoFailed, (state: State) => ({
    ...state, isDeletingMitarbeiter: false
  })),

  on(deleteMitarbeiterStart, (state: State) => ({ ...state, isDeletingMitarbeiter: true })),
  on(deleteMitarbeiterFailed, (state: State) => ({ ...state, isDeletingMitarbeiter: false })),
  on(deleteMitarbeiterSucceeded, (state: State) => ({
    ...state, isDeletingMitarbeiter: false
  })),

  on(deleteRolleStart, (state: State) => ({ ...state, isDeletingRolle: true })),
  on(deleteRolleFailed, (state: State, action) => ({
    ...state,
    isDeletingRolle: false,
    rollen: {
      ...state.rollen,
      error: action.error,
    },
  })),
  on(deleteRolleSucceeded, (state: State) => ({
    ...state,
    isDeletingRolle: false,
    rollen: {
      ...state.rollen,
      error: '',
    }
  })),
  on(changeRolleStart, (state: State) => ({ ...state, isChangingRolle: true })),
  on(changeRolleSucceeded, (state: State) => ({ ...state, isChangingRolle: false })),
  on(changeRolleFailed, (state: State) => ({ ...state, isChangingRolle: false })),
];

export const mitarbeiterverwaltungReducer = createReducer(initialState, ...ons);
